import React from 'react'
import './MenuIdiomasV.css'

import { connect } from 'react-redux'

import { useSpring, animated } from 'react-spring'

const MenuIdiomasV = ({ visible, grupoProyecto, idProyecto }) => {
  const { opacity, top } = useSpring({
    opacity: visible ? 1 : 0,
    top: visible ? '0.5em' : '-5em'
  })

  return (
    <animated.div
      className="menu-v"
      style={{
        opacity,
        top,
        left: '6em',
        width: '17em',
        border: '1px solid white',
        alignSelf: 'center'
      }}
    >
      {grupoProyecto.map(proyecto => (
        <div
          className="menu-v-a"
          style={{
            fontWeight: idProyecto === proyecto.id ? 500 : 300
          }}
          onClick={e => {
            window.location.href = proyecto.url
          }}
        >
          {proyecto.title.toUpperCase()}
        </div>
      ))}
    </animated.div>
  )
}

const mapStateToProps = ({ reducer }, ownProps) => {
  return {
    visible: reducer.openProyecto,
    grupoProyecto: reducer.grupoProyecto,
    idProyecto: reducer.idProyecto
  }
}

const mapDispatchToProps = {}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuIdiomasV)
